import { useLocale } from 'shared/hooks/useLocale';
import { getShortLocale } from 'shared/utils/locale';

export function useLanguageValue() {
  const locale = useLocale();
  return getShortLocale(locale);
}
